/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_h_act_veryactive1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very active`)
};

const es_h_act_veryactive1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muy activo`)
};

const de_h_act_veryactive1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehr aktiv`)
};

const nl_h_act_veryactive1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeer actief`)
};

const fr_h_act_veryactive1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Très actif`)
};

const it_h_act_veryactive1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molto attivo`)
};

const pt_br2_h_act_veryactive1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muito ativo`)
};

const pt_h_act_veryactive1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muito ativo`)
};

const ja_h_act_veryactive1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常に活発`)
};

const zh_h_act_veryactive1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常活跃`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const h_act_veryactive1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.h_act_veryactive1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("h_act_veryactive1", locale)
	if (locale === "en") return en_h_act_veryactive1(inputs)
	if (locale === "es") return es_h_act_veryactive1(inputs)
	if (locale === "de") return de_h_act_veryactive1(inputs)
	if (locale === "nl") return nl_h_act_veryactive1(inputs)
	if (locale === "fr") return fr_h_act_veryactive1(inputs)
	if (locale === "it") return it_h_act_veryactive1(inputs)
	if (locale === "pt-BR") return pt_br2_h_act_veryactive1(inputs)
	if (locale === "pt") return pt_h_act_veryactive1(inputs)
	if (locale === "ja") return ja_h_act_veryactive1(inputs)
	return zh_h_act_veryactive1(inputs)
};
export { h_act_veryactive1 as "h_act_veryActive" }